// src/middleware/authErrorMiddleware.js
import { logout } from "../../slices/userSlice";

export const authErrorMiddleware = (store) => (next) => (action) => {
  if (action.type?.endsWith("/rejected")) {
    const payload =
      typeof action.payload === "string"
        ? action.payload
        : "";

    const isLocked =
      payload.includes("423") ||
      payload.includes("Account locked");

    const isAuthError =
      payload.includes("401") ||
      payload.includes("403") ||
      payload.includes("Authentication failed") ||
      payload.includes("No auth token");

    if (isLocked || isAuthError) {
      store.dispatch(logout());

      if (window.location.pathname !== "/login") {
        window.location.href = isLocked
          ? "/login?reason=locked"
          : "/login?reason=expired";
      }
    }
  }

  return next(action);
};